export default __webpack_public_path__ + "static/media/mapsThumbnail.6d464a53.png";